import { ExperimentOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Collapse, Divider } from "antd";
const { Panel } = Collapse;

function ImprovementPanel({
  improvements,
  questions,
  remarks,
  text,
  title,
  removalFunc,
  index,
  improvementFunc,
  summary,
}) {
  const removeSelf = () => {
    console.log(index);
    removalFunc(index);
  };

  const improveSelf = () => {
    console.log(index);
    improvementFunc(index, text);
  };

  return (
    <div className="flex flex-col border border-gray-300 bg-white rounded-lg shadow-lg mr-10 ml-3 my-3 p-4 h-fit">
      <div className="flex flex-col space-y-4">
        <div className="font-medium text-xl">{title}</div>
        <div className="flex flex-col">
          <Collapse size="small">
            <Panel header="Original Text" key="1">
              <p className="font-light text-xs">{text}</p>
            </Panel>
            <Panel header="Summary" key="2">
              <p className="font-light text-xs">{summary}</p>
            </Panel>
          </Collapse>
        </div>
        <div className="font-medium text-lg">improvements</div>
        <div className="flex flex-col">
          {improvements.map((improvement, index) => {
            return (
              <div className="flex flex-row space-x-2 items-start mb-3">
                <input
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="mt-2 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                ></input>
                <div className="font-light text-md">{improvement}</div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col space-y-4">
          <div className="font-medium text-lg">questions</div>
          <div className="flex flex-col">
            {questions.map((question, index) => {
              return (
                <div className="flex flex-row space-x-2 items-start mb-3">
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    className="mt-2 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  ></input>
                  <div className="font-light text-md">{question}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col space-y-4">
          <div className="font-medium text-lg">remarks</div>
          <div className="flex flex-col space-y-2">
            {remarks.map((remark, index) => {
              return (
                <div className="flex flex-row space-x-2">
                  <div className="font-medium text-lg">{index + 1}.</div>
                  <div className="font-light text-md">{remark}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={improveSelf}
        className="mt-10 rounded-lg bg-indigo-900 px-4 py-2 text-md font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none"
      >
        magic fix{" "}
        <ExperimentOutlined
          style={{ verticalAlign: "1px", marginLeft: "2px" }}
        />
      </button>
      <button
        type="button"
        onClick={removeSelf}
        className="mt-3 rounded-lg bg-green-700 px-4 py-2 text-md font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none"
      >
        mark as done{" "}
        <CheckCircleOutlined
          style={{ verticalAlign: "1px", marginLeft: "2px" }}
        />
      </button>
    </div>
  );
}

export default ImprovementPanel;
